import { CanalVendaID } from './canal-venda.id';

/** Representa um canal de venda */
export interface CanalVenda {
    id: CanalVendaID;
    nome: string;
    descricao: string;
    logoURL: string;
    logoMiniURL: string;
}

export namespace CanalVenda {
    /** Canal de venda Direto */
    export const CANAL_VENDA_DIRETO: CanalVenda = {
        id: CanalVendaID.DIRETO,
        nome: 'Direto',
        descricao: 'Vendas diretas pela empresa',
        logoURL: '',
        logoMiniURL: ''
    };

    /** Canal de venda Loja Virtual */
    export const CANAL_VENDA_LOJA_VIRTUAL: CanalVenda = {
        id: CanalVendaID.LOJA_VIRTUAL,
        nome: 'Loja Virtual',
        descricao: 'E-commerce próprio',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/loja-virtual.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/loja-virtual.png'
    };

    /** Canal de venda Amazon */
    export const CANAL_VENDA_AMAZON: CanalVenda = {
        id: CanalVendaID.AMAZON,
        nome: 'Amazon',
        descricao: 'Marketplace Amazon',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/amazon.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/amazon-mini.png'
    };

    /** Canal de venda Americanas Marketplace */
    export const CANAL_VENDA_AMERICANAS_MARKETPLACE: CanalVenda = {
        id: CanalVendaID.AMERICANAS_MARKETPLACE,
        nome: 'Americanas Marketplace',
        descricao: 'Americanas Marketplace',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/amaricanas-markeplace.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/amaricanas-markeplace-mini.png'
    };

    /** Canal de venda Carrefour Marketplace */
    export const CANAL_VENDA_CARREFOUR_MARKETPLACE: CanalVenda = {
        id: CanalVendaID.CARREFOUR_MARKETPLACE,
        nome: 'Carrefour Marketplace',
        descricao: 'Carrefour Marketplace',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/carrefour.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/carrefour-mini.png'
    };

    /** Canal de venda Casas Bahia Marketplace */
    export const CANAL_VENDA_CASAS_BAHIA_MARKETPLACE: CanalVenda = {
        id: CanalVendaID.CASAS_BAHIA_MARKETPLACE,
        nome: 'Casas Bahia Marketplace',
        descricao: 'Casas Bahia Marketplace',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/casas-bahia.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/casas-bahia-mini.png'
    };

    /** Canal de venda Centauro */
    export const CANAL_VENDA_CENTAURO: CanalVenda = {
        id: CanalVendaID.CENTAURO,
        nome: 'Centauro',
        descricao: 'Centauro Marketplace',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/centauro.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/centauro-mini.png'
    };

    /** Canal de venda Dafiti */
    export const CANAL_VENDA_DAFITI: CanalVenda = {
        id: CanalVendaID.DAFITI,
        nome: 'Dafiti',
        descricao: 'Dafiti Marketplace',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/dafiti.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/dafiti-mini.png'
    };

    /** Canal de venda Magalu Marketplace */
    export const CANAL_VENDA_MAGALU_MARKETPLACE: CanalVenda = {
        id: CanalVendaID.MAGALU_MARKETPLACE,
        nome: 'Magalu Marketplace',
        descricao: 'Magalu Marketplace',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/magazine-luiza.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/magazine-luiza-mini.png'
    };

    /** Canal de venda Mercado Livre */
    export const CANAL_VENDA_MERCADO_LIVRE: CanalVenda = {
        id: CanalVendaID.MERCADO_LIVRE,
        nome: 'Mercado Livre',
        descricao: 'Mercado Livre',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/mercado-livre.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/mercado-livre-mini.png'
    };

    /** Canal de venda Netshoes */
    export const CANAL_VENDA_NETSHOES: CanalVenda = {
        id: CanalVendaID.NETSHOES,
        nome: 'Netshoes',
        descricao: 'Netshoes Marketplace',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/netshoes.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/netshoes-mini.png'
    };

    /** Canal de venda Shein */
    export const CANAL_VENDA_SHEIN: CanalVenda = {
        id: CanalVendaID.SHEIN,
        nome: 'Shein',
        descricao: 'Shein Marketplace',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/shein.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/shein-mini.png'
    };

    /** Canal de venda Shopee */
    export const CANAL_VENDA_SHOPEE: CanalVenda = {
        id: CanalVendaID.SHOPEE,
        nome: 'Shopee',
        descricao: 'Shopee Marketplace',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/shopee.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/shopee-mini.png'
    };

    /** Canal de venda Facebook Shops */
    export const CANAL_VENDA_FACEBOOK_SHOPS: CanalVenda = {
        id: CanalVendaID.FACEBOOK_SHOPS,
        nome: 'Facebook Shops',
        descricao: 'Facebook Shops',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/facebook.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/facebook-mini.png'
    };

    /** Canal de venda Instagram Shopping */
    export const CANAL_VENDA_INSTAGRAM_SHOPPING: CanalVenda = {
        id: CanalVendaID.INSTAGRAM_SHOPING,
        nome: 'Instagram Shopping',
        descricao: 'Instagram Shopping',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/instagram.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/instagram-mini.png'
    };

    /** Canal de venda TikTok Shop */
    export const CANAL_VENDA_TIKTOK_SHOP: CanalVenda = {
        id: CanalVendaID.TIKTOK_SHOP,
        nome: 'TikTok Shop',
        descricao: 'TikTok Shop',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/tiktok-shop.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/tiktok-shop-mini.png'
    };

    /** Canal de venda WhatsApp Business */
    export const CANAL_VENDA_WHATSAPP_BUSINESS: CanalVenda = {
        id: CanalVendaID.WHATSAPP_BUSINESS,
        nome: 'WhatsApp Business',
        descricao: 'WhatsApp Business',
        logoURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/whatsapp-business.png',
        logoMiniURL: 'https://sogivendas.s3.sa-east-1.amazonaws.com/public/canais-venda/whatsapp-business-mini.png'
    };

    /** Retorna todos os canais de venda */
    export function getAll(): CanalVenda[] {
        return [
            CANAL_VENDA_DIRETO,
            CANAL_VENDA_LOJA_VIRTUAL,
            CANAL_VENDA_AMAZON,
            CANAL_VENDA_AMERICANAS_MARKETPLACE,
            CANAL_VENDA_CARREFOUR_MARKETPLACE,
            CANAL_VENDA_CASAS_BAHIA_MARKETPLACE,
            CANAL_VENDA_CENTAURO,
            CANAL_VENDA_DAFITI,
            CANAL_VENDA_MAGALU_MARKETPLACE,
            CANAL_VENDA_MERCADO_LIVRE,
            CANAL_VENDA_NETSHOES,
            CANAL_VENDA_SHEIN,
            CANAL_VENDA_SHOPEE,
            CANAL_VENDA_FACEBOOK_SHOPS,
            CANAL_VENDA_INSTAGRAM_SHOPPING,
            CANAL_VENDA_TIKTOK_SHOP,
            CANAL_VENDA_WHATSAPP_BUSINESS
        ];
    }

    /** Obtém o canal de venda pelo id */
    export function getById(id: number): CanalVenda | undefined {
        return getAll().find(canal => canal.id === id);
    }
}
